import React from 'react';
import { createRoot } from 'react-dom/client';
import FlightDetails from './components/FlightDetails.jsx';

// Функция для открытия модального окна
export const openFlightDetails = (flightNumber) => {
  // Удаляем существующее модальное окно
  const existingContainer = document.getElementById('flight-details-root');
  if (existingContainer) {
    document.body.removeChild(existingContainer);
  }

  const container = document.createElement('div');
  container.id = 'flight-details-root';
  document.body.appendChild(container);

  const root = createRoot(container);
  
  const handleClose = () => {
    root.unmount();
    if (container.parentNode) {
      document.body.removeChild(container);
    }
  };

  root.render(
    <FlightDetails 
      flightNumber={flightNumber} 
      onClose={handleClose} 
    />
  );
};

// Делаем доступным глобально
if (typeof window !== 'undefined') {
  window.openFlightDetails = openFlightDetails;
}